module.exports = __webpack_public_path__ + "img/pelevin.9fd71d28.jpg";